<template>
  <Row>
    <Timeline>
      <TimelineItem v-for="review in reviews" :key="review.id">
        <FFIcon
          :type="icon(review.status)"
          :hclass="icon(review.status)"
          slot="dot"
        ></FFIcon>
        <span>
          <h3 :class="icon(review.status)">{{ review.status }}</h3>
          <small class="hash">#{{ review.id }}</small>
          <strong>{{ review.created_by }}</strong>
          {{ review.created_at | date }}
          <p class="content">{{ review.comment }}</p>
        </span>
      </TimelineItem>
    </Timeline>
    <Card dis-hover>
      <p slot="title">Review</p>
      <i-form>
        <i-form-item label="Status">
          <RadioGroup v-model="review.status" type="button">
            <Radio
              v-for="(value, option) in options"
              :key="option"
              :label="option"
              :disabled="!enableOption(option)"
            >
              <FFIcon
                :type="icon(option)"
                :hclass="enableOption(option) ? icon(option) : ''"
              ></FFIcon
              >{{ option }}
            </Radio>
          </RadioGroup>
        </i-form-item>
        <i-form-item label="Comment">
          <i-input
            v-model="review.comment"
            type="textarea"
            spellcheck
            :rows="4"
          ></i-input>
        </i-form-item>
        <i-button @click="save">
          <FFIcon
            :type="icon(review.status)"
            :hclass="icon(review.status)"
          ></FFIcon>
          Post {{ review.status }}
        </i-button>
      </i-form>
    </Card>
  </Row>
</template>

<script>
import database from "@/database";
import moment from "moment";

export default {
  props: ["id", "type"],
  data() {
    return {
      reviews: [],
      lastStatus: "",
      review: {
        entity_id: this.id,
        entity_type: this.type,
        status: "Comment",
        comment: "",
      },
      options: Object.freeze({
        Comment: 0,
        "Under Review": 1,
        "Review Completed": 2,
        "Signed Off": 3,
        "Locked Down": 4,
      }),
    };
  },
  created() {
    this.load();
  },
  filters: {
    date(value) {
      return moment(value).format("dddd DD/MM/YYYY hh:mm");
    },
  },
  methods: {
    debug() {
      // console.log(this.enableOption(this.review.status));
      console.log(this.review);
    },
    enableOption(option) {
      if (option === "Comment") {
        return this.$can("comment_on_review", "facts");
      }

      // from user
      let superReviewer =
        this.$can("sign_off", "facts") || this.$can("lock_down", "facts");
      // this.user.permissions && this.user.permissions.superReviewer;

      // Check action index with latest status
      let enabled = this.options[option] > this.lastStatus;
      enabled = enabled || superReviewer;

      if (
        !superReviewer &&
        (option === "Signed Off" || option === "Locked Down")
      ) {
        return false;
      }

      switch (option) {
        case "Under Review":
          enabled = enabled && this.$can("review", "facts");
          break;
        case "Review Completed":
          enabled = enabled && this.$can("complete_review", "facts");
          break;
      }

      return enabled;
    },
    load() {
      if (this.id !== null) {
        database
          .search("reviews", {
            entity_id: `eq.${this.id}`,
            entity_type: `eq.${this.type}`,
            order: "created_at",
          })
          .then(response => {
            this.reviews = response.data;
            let actions = this.reviews.filter(
              review => review.status !== "Comment"
            );

            // Get index of action
            let lastReview = actions[actions.length - 1];
            this.lastStatus = lastReview ? this.options[lastReview.status] : 0;
          })
          .catch(error => {
            console.error(error);
          });
      }
    },
    save() {
      if (this.enableOption(this.review.status)) {
        database
          .save("reviews", this.review, {})
          .then(() => {
            this.load();
          })
          .catch(error => {
            console.error(error);
          });
      }
    },
    icon(value) {
      switch (value) {
        case "Comment":
          return "comment";
        case "Under Review":
          return "search";
        case "Review Completed":
          return "check";
        case "Signed Off":
          return "pencil";
        case "Locked Down":
          return "lock";
        default:
          return "comment";
      }
    },
  },
};
</script>

<style>
.time h3 {
  margin: 0;
  padding: 0;
}
.comment {
  color: #5c738e;
}
.search {
  color: #dc722d;
}
.check {
  color: #748a5a;
}
.pencil {
  color: #50a090;
}
.lock {
  color: #296ca2;
}
.hash {
  color: gray;
}
</style>
